import { I18n } from "Utils/types";

export const BottomDetailsPanelWidth = 730;
export const Titles: Record<string, I18n> = {
    location: {
        en: "Location",
        he: "מיקום",
    },
    programma: {
        en: "Programma",
        he: "פרוגרמה",
    },
    at: {
        en: "at",
        he: "ב-"
    }
}